import { ElIcon } from './icon';

export interface ElIcons {
  [key: string]: ElIcon | string;
}

export enum ElIconPackType  {
  SVG = 'svg',
  FONT = 'font',
}

export interface ElIconPackParams {
  packClass?: string,
  [name: string]: any,
}

export interface ElFontIconPackParams extends ElIconPackParams {
  iconClassPrefix?: string,
}

export interface ElIconPack {
  name: string;
  type: ElIconPackType;
  icons: Map<string, ElIcon | string>;
  params: ElIconPackParams,
}
